import React from "react";
import { Col, Form } from "react-bootstrap";
import { useFormikContext } from "formik";
import { ProductForSale } from "../../types";
import PriceInputSale from "./PriceInputSale";

interface AmountRadioGroupProps {
    name: string;
    id: string;
    isDiscount: boolean;
    toggleRadioButton: () => void;
    index: number;
    price: number;
    disabled: boolean;
}

const AmountRadioGroup: React.FC<AmountRadioGroupProps> = ({
    name,
    id,
    isDiscount,
    toggleRadioButton,
    index,
    price,
    disabled,
}) => {
    const { values } = useFormikContext<{ productsInput: ProductForSale[] }>();

    return (
        <Col xs="auto" className="px-0 d-flex align-items-start">
            <div className="position-relative">
                <Form.Check
                    type="radio"
                    name={`radio-discount-toggle-${index}`}
                    className="position-absolute top-50 start-0 translate-middle-y ms-6 z-1"
                    disabled={disabled}
                    checked={!isDiscount}
                    onChange={toggleRadioButton}
                />
                <PriceInputSale
                    id={id}
                    name={name}
                    placeholder="0.00"
                    initialValue={
                        Number(values?.productsInput?.[index]?.amount) ||
                        (values?.productsInput?.[index].storageProductRelationId && values?.productsInput?.[index].unit
                            ? 0.01
                            : 0)
                    }
                    disabled={isDiscount || disabled}
                    isRadioButton={true}
                />
            </div>
        </Col>
    );
};

export default AmountRadioGroup;
